import React from "react";
import {
  FormDataKey,
  QuestionAttribute,
  SignUpFormData,
} from "../../../../SignUpFormTypes/signUpFormTypes";
import { Controller, useFormContext } from "react-hook-form";
import { signUpFormValidators } from "../../../../helpers/signUpFormConstants";
import * as Checkbox from "@radix-ui/react-checkbox";
import Check from "../../../../svgs/FilledCheck";
import { CheckedState } from "@radix-ui/react-checkbox";
import { isStringArray } from "../../signUpHelpers";

const MultipleChoice: React.FC<QuestionAttribute & { index: number }> = ({
  questionTitle,
  questionDropdownOptions,
  index,
  questionOptional,
}) => {
  const { control } = useFormContext<SignUpFormData>();
  const INPUT_NAME = `questions.${index}.value`;

  const handleOnChange =
    (
      arrayOfString: string[],
      valueChecked: string,
      hookChangeFunction: (...event: any[]) => void
    ) =>
    (checked: CheckedState): void => {
      let newArray = [...arrayOfString];
      if (!checked) newArray = arrayOfString.filter(v => v !== valueChecked);
      else newArray.push(valueChecked);
      return hookChangeFunction(newArray);
    };

  return (
    <Controller
      name={INPUT_NAME as FormDataKey}
      rules={
        questionOptional
          ? signUpFormValidators.optional
          : signUpFormValidators.required
      }
      control={control}
      render={({
        field: { value, onChange, ...field },
        fieldState: { invalid },
      }) => (
        <div className="flex flex-col items-start gap-6 sm:gap-4 self-stretch">
          <div className="flex flex-col items-start gap-1 self-stretch">
            <label
              className={`font-sans text-base not-italic font-normal leading-[160%]
              flex justify-between items-center w-full`}
            >
              <div>
                What are your needs?{" "}
                <span className="text-forest-600">(Select all that apply)</span>
              </div>
              {questionOptional && (
                <span
                  className="flex h-6 px-2 py-1 justify-center items-center gap-2.5 self-center
                  text-sm font-normal not-italic leading-[165%] text-forest-900 bg-forest-100 rounded-full"
                >
                  Optional
                </span>
              )}
            </label>
            {invalid && (
              <p className="font-sans text-base not-italic font-normal leading-[160%] text-clay-700">
                Select at least one option to continue
              </p>
            )}
          </div>
          <div className="flex flex-col items-start gap-3 self-stretch px-3">
            {questionDropdownOptions &&
              questionDropdownOptions.map(({ dropdown }) => {
                if (!isStringArray(value)) return;

                const isChecked = value.some(v => v === dropdown);

                return (
                  <div
                    key={dropdown}
                    className="flex justify-start items-center gap-[10px] self-stretch"
                  >
                    <Checkbox.Root
                      id={`${INPUT_NAME}-${dropdown}`}
                      checked={isChecked}
                      value={dropdown}
                      onCheckedChange={handleOnChange(
                        value as string[],
                        dropdown,
                        onChange
                      )}
                      className={`flex flex-col size-5 items-start gap-2 shrink-0 rounded
                        ${!isChecked && "border border-solid border-[#DDD]"}
                        ${invalid ? "bg-clay-200" : "bg-white"}`}
                      {...field}
                    >
                      <Checkbox.Indicator className="size-full shrink-0 text-forest-900">
                        <Check background="#FFC600" stroke="#123333" />
                      </Checkbox.Indicator>
                    </Checkbox.Root>
                    <label
                      className="font-sans text-base text-[#333] not-italic font-normal leading-[160%] cursor-pointer"
                      htmlFor={`${INPUT_NAME}-${dropdown}`}
                    >
                      {dropdown}
                    </label>
                  </div>
                );
              })}
          </div>
        </div>
      )}
    />
  );
};

export default MultipleChoice;
